// CustomFilterModal.tsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import CustomFilterStep from './CustomFilter';

type CustomFilterModalProps = {
  open: boolean;
  onClose: () => void;
  setFilterValues: (filterValues: FilterState) => void;
  categoricalColumns: any;
  numericColumns: any;
  selectedItems?: SelectedItems;
  axisFilterState?: FilterState;
  saveAxis?: boolean;
};

const CustomFilterModal: React.FC<CustomFilterModalProps> = ({
  open,
  onClose,
  setFilterValues,
  categoricalColumns,
  numericColumns,
  selectedItems,
  axisFilterState,
  saveAxis,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogContent>
        <CustomFilterStep
          setFilterValues={setFilterValues}
          categoricalColumns={categoricalColumns}
          numericColumns={numericColumns}
          selectedItems={selectedItems}
          axisFilterState={axisFilterState ?? {}}
          saveAxis={saveAxis}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        {/* <Button color="primary" onClick={onSave}>
            Save
        </Button> */}
        </DialogActions>
    </Dialog>
  );
};

export default CustomFilterModal;